import {
    CommonRoutes,
} from 'app/enums/common.enums'
import ContainersDashboardDemoPage from 'app/PoC/DataGridDemoPages/ContainersDemo/ContainersDashboardDemoPage'

export default [{
    path: CommonRoutes.Index,
    element: <ContainersDashboardDemoPage />,
}]
